import {requestUrl, requestHeaders, requestOptions} from '../../../graphQLClient.js'
import Vue from 'vue';

const CSV = 'CSV';

export default {

  setReportData({commit, state}, data){
    commit('setReportData', data);
  },

  setReportSummaryData({commit, state}, data){
    commit('setReportSummaryData', data);
  },

  setReportChartsData({commit, state}, data){
    commit('setReportChartsData', data);
  },

  setReportTotalCount({commit, state}, data){
    commit('setReportTotalCount', data)
  },

  setReportPaginationInfo({commit, state}, data){
    commit('setReportPaginationInfo', data)
  },

  setReportDataB({commit, state}, data){
    commit('setReportDataB', data);
  },

  setReportTotalCountB({commit, state}, data){
    commit('setReportTotalCountB', data)
  },

  setReportPaginationInfoB({commit, state}, data){
    commit('setReportPaginationInfoB', data)
  },

  setFixedColumns({commit, state}, data){
    commit('setFixedColumns', data)
  },

  setSummaryChartsData({commit, state}, data){
    commit('setSummaryChartsData', data)
  },

  setCurrentRowsCount({commit, state}, count){
    commit('setCurrentRowsCount', count);
  },

  setDateComparisonFields({commit, state}, fields){
    commit('setDateComparisonFields', fields);
  },

  setSorting({commit, state}, sortingColumn){
    commit('setSorting', sortingColumn);
  },
  setSortingDirection({commit, state}, sortingDirection){
    commit('setSortingDirection', sortingDirection);
  },
  setHoverStatuses({commit, state}, statuses){
    commit('setHoverStatuses', statuses);
  },
  setSideBarStatus({commit, state}, status){
    commit('setSideBarStatus', status);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/baseReport/table/actions.js